<template>
  <div>
    <Row class="u-padding__vertical--2" verticalCenter>
      <Col :xs="10">
        <slot name="left" />
      </Col>
      <Col :xs="2" right>
        <slot name="right" />
      </Col>
    </Row>
    <Divider />
  </div>
</template>

<script>
import Divider from '@/objects/Divider';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

export default {
  name: 'TableRow',
  props: {
    hideDivider: Boolean,
  },
  components: {
    Divider,
    Row,
    Col,
  },
};
</script>
